import styled from 'styled-components';

export default styled.div`
  margin-top: 20px;
  width: 100%;
  @media (min-width: 576px) {
    box-shadow: 0 4px 64px 4px rgba(0, 0, 0, 0.15);
  }
`;
